import { render, staticRenderFns } from "./detail-wrapper.vue?vue&type=template&id=db6db3b2&scoped=true"
import script from "./detail-wrapper.vue?vue&type=script&lang=js"
export * from "./detail-wrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db6db3b2",
  null
  
)

export default component.exports